module.exports = __webpack_public_path__ + "static/media/arm.ebdc3521.svg";